import { createFileRoute } from "@tanstack/react-router";
import { SettingsScreen } from "@ui/screens/SettingsScreen";

export const Route = createFileRoute("/settings")({
  component: SettingsScreen,
});
